// TODO: Check if this is needed here
// This is required for IE (previously used as babel-polyfill, which is now deprecated)
// Also imported in src/index.js (for PWA)
import "core-js/stable";
import "regenerator-runtime/runtime";

import React from 'react';
import ReactDOM from 'react-dom';
import Widget from './widget';
import { getPlain } from 'src/utils/request-client';
import { getBrandingCssUri, isLocal, getBrandSettings, logError, isEmpty, getStaticUrl } from 'src/utils/helpers';
import BrokerService from 'src/utils/broker-service';

// Also imported in src/index.js (for PWA)
import elementClosest from 'element-closest';
import * as Sentry from '@sentry/browser';

//This is a IE11 fix that is needed for slate editor to work
// Slate editor is currently not used, but it might still be needed for something else
elementClosest(window);

/**
 * Add "intl" as polyfill to solve this error:
 * [React Intl] The `Intl` APIs must be available in the runtime, and do not appear to be built-in. An `Intl` polyfill should be loaded.
 * See: http://formatjs.io/guides/runtime-environments/
 */
if (!global.Intl) {
  global.Intl = require('intl'); 
}
if (!window.Intl) {
  window.Intl = require('intl');
}

const staticUrl = getStaticUrl();

const sentryDnsAndToken = process.env.REACT_APP_SENTRY || null

Sentry.init({
  dsn: isLocal() ? null : sentryDnsAndToken,
  release: process.env.REACT_APP_VERSION,
  maxBreadcrumbs: 50,
  // Regex list of URLs to include in Sentry reports (just our app since this is for widget)
  whitelistUrls: [
    new RegExp(`${staticUrl}.*`),
    new RegExp(`${process.env.REACT_APP_API_BASE}.*`),
  ],
});


export default class PathwayWidget {
  static el;

  static mount(properties) {
    setWidgetStyle();
    BrokerService.setBroker(properties.broker);

    function setWidgetStyle() {
      const link = document.createElement('link');
      link.href = `${staticUrl}/widget/main.css`;
      link.rel = "stylesheet";
      link.type = "text/css";
      document.head.appendChild(link);
    }

    async function fetchColors() {
      try {
        const settings = await getBrandSettings('w');

        if (typeof settings !== 'object' || isEmpty(settings) || settings.hasOwnProperty('error')) {
          return {};
        }

        return settings && settings.data && settings.data.data && settings.data.data.colors;
      } catch (e) {
        logError('Get colors from brand settings', e);
        return null;
      }
    }

    async function fetchBrandingCSS(colors) {
      const response = await getPlain(getBrandingCssUri(colors));

      return response && response.data && response.data.data && response.data.data.css;
    }

    async function fetchCoreCss() {
      const response = await getPlain(`${staticUrl}/get-generated-styles?type=core`);

      return response && response.data && response.data.data;
    }

    async function fetchButtonCss() {
      const response = await getPlain(`${staticUrl}/get-generated-styles?type=button`);

      return response && response.data && response.data.data;
    }

    async function doRender() {
      if (PathwayWidget.el) {
        throw new Error('PathwayWidget is already mounted, unmount first');
      }

      const colors = await fetchColors();
      let brandingStyles = '';
      if(!isEmpty(colors)) {
        brandingStyles = await fetchBrandingCSS(colors);
      }

      const coreStyles = await fetchCoreCss();
      const buttonStyles = await fetchButtonCss();

      const el = document.createElement('div');
      el.id = "pathway-widget";
      document.body.appendChild(el);
      ReactDOM.render(<Widget
        colors={colors}
        css={{
          brandingStyles,
          coreStyles,
          buttonStyles
        }}
        openOnLoad={properties.hasOwnProperty('openOnLoad') ? properties.openOnLoad : true }
        sound={properties.hasOwnProperty('sound') ? properties.sound : true }
        widgetLanguage={properties.hasOwnProperty('language') ? properties.language : null }
        onIsActiveChange={properties.hasOwnProperty('onIsActiveChange') ? properties.onIsActiveChange : null}
        { ...properties }
      />, el);
      PathwayWidget.el = el;
    }

    if (document.readyState === 'complete') {
      doRender();
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => doRender());
      });
    }
  }

  static unmount() {
    if (!PathwayWidget.el) {
      throw new Error('PathwayWidget is not mounted, mount first');
    }
    ReactDOM.unmountComponentAtNode(PathwayWidget.el);
    PathwayWidget.el.parentNode.removeChild(PathwayWidget.el);
    PathwayWidget.el = null;
  }
}
